import * as React from 'react'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import withStyles from '@material-ui/core/styles/withStyles'
import { Paper, WithStyles, createStyles } from '@material-ui/core'

interface ILayoutProps extends WithStyles<typeof styles> {}

const Layout: React.SFC<ILayoutProps> = props => {
  const { classes, children: currentView } = props

  return (
    <main className={classes.layout}>
      <Paper className={classes.paper}>{currentView}</Paper>
    </main>
  )
}

const styles = ({ spacing, breakpoints }: Theme) =>
  createStyles({
    layout: {
      width: 'auto',
      marginLeft: spacing.unit * 2,
      marginRight: spacing.unit * 2,
      [breakpoints.up(600 + spacing.unit * 2 * 2)]: {
        width: 600,
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    },
    paper: {
      marginTop: spacing.unit * 3,
      marginBottom: spacing.unit * 3,
      padding: spacing.unit * 2,
      [breakpoints.up(600 + spacing.unit * 3 * 2)]: {
        marginTop: spacing.unit * 6,
        marginBottom: spacing.unit * 6,
        padding: spacing.unit * 3
      }
    }
  })

export default withStyles(styles)(Layout)



// WEBPACK FOOTER //
// ./src/components/layout/Layout.tsx